import { ApiError } from './api';

/** Serializes requests whose responses may change the HttpOnly session cookie. */
export class AuthTransitionGate {
  private active = false;
  private unauthorizedDeferred = false;

  begin(): void {
    if (this.active) throw new ApiError(409, 'auth_transition_pending', 'Another sign-in or sign-out is still finishing.');
    this.active = true;
  }

  deferUnauthorized(): boolean {
    if (!this.active) return false;
    this.unauthorizedDeferred = true;
    return true;
  }

  finish(): boolean {
    this.active = false;
    const deferred = this.unauthorizedDeferred;
    this.unauthorizedDeferred = false;
    return deferred;
  }
}
